import type { Currency } from '@backmarket/http-api/src/standards/Currency'
import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'

export function updateUserContext() {
  const { user, isUserAuthenticatedStaff } = useUserStore()
  const tracking = useTracking()

  if (!user.value.userId) {
    tracking.setAnonymousUserDataContext()

    return
  }

  tracking.setUserContext({
    userId: user.value.userId,
    isStaff: isUserAuthenticatedStaff.value,
    clientId: user.value.clientId,
    bmUserId: user.value.bmUserId,
    accountCreationDate: user.value.accountCreationDate,
    emailHashed: user.value.emailHashed || '',
    merchantId: user.value.merchantId,
    lastOrderDate: user.value.lastOrderDate
      ? String(user.value.lastOrderDate)
      : '',
    numberOfOrders: user.value.numberOfOrders,
    lifetimeRevenue: {
      currency: <Currency>user.value.lifetimeRevenue.currency || '',
      amount: String(user.value.lifetimeRevenue.amount),
    },
  })

  if (!user.value.clientId) {
    return
  }

  if (user.value.bmUserId) {
    tracking.setCrmId(user.value.bmUserId)
  } else {
    useLogger().error(
      '[LIF][CRM][UserContext] Missing bmUserId for authenticated client',
      {
        userId: user.value.userId,
        feature: 'braze-crm-integration',
        owners: ['bot-squad-lifecycle-front'],
      },
    )
  }
}
